import React from 'react';
import './Home.css';

const stats = [
  { value: '15+', label: 'Years Experience' },
  { value: '2', label: 'Leadership Roles' },
  { value: '30%+', label: 'Cost Savings Delivered' },
  { value: '500+', label: 'Systems Deployed' },
];

const Home = () => {
  return (
    <div className="home">
      <div className="hero-blob hero-blob-1"></div>
      <div className="hero-blob hero-blob-2"></div>

      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title animated-text">Tim Patterson</h1>
          <p className="hero-subtitle animated-text">
            IT &amp; Cybersecurity Professional | Sales &amp; Account Management
          </p>
          <div className="skills-container">
            <span className="skill-tag">Cybersecurity</span>
            <span className="skill-tag">IT Infrastructure</span>
            <span className="skill-tag">Security Assessment</span>
            <span className="skill-tag">Cloud Solutions</span>
          </div>
          <div className="hero-cta">
            <a href="#contact" className="primary-button">Get in Touch</a>
            <a href="#about" className="secondary-button">Learn More</a>
            <a href="/Tim_Patterson_Resume.pdf" download="Tim-Patterson-Resume.pdf" className="download-button">
              Download CV
            </a>
          </div>
        </div>
      </div>

      <div className="stats-strip">
        {stats.map((stat, i) => (
          <div key={i} className="stat-card">
            <span className="stat-value">{stat.value}</span>
            <span className="stat-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
